export const WebActionCharacterLimits = {
  name: 128,
  // this is the max length we can do for the input description field as it is used in the
  // tool call description and that has a max length of 1024
  // For any future travelers, here is a workaround for if we need to update past the limit
  // https://docs.llamaindex.ai/en/stable/examples/agent/openai_agent_lengthy_tools/#defining-an-excessively-lengthy-query-plan
  description: 2 ** 10,
  inputName: 64,
  inputDescription: 512,
  url: 2048,
  headerName: 128,
  headerValue: 2 ** 12,
  requestBody: 2 ** 20,
  outputKey: 1024,
  outputName: 64,
} as const;
